import Emitter from "es6-event-emitter";
import { generateCoverURL } from "./../utilities/utils";

export default class PromospotStore extends Emitter {
  promospotList = null;

  _apiManager = null;

  _imageSizes = null;

  constructor(apiManager, imageSizes, options) {
    super();
    this._apiManager = apiManager;
    this._imageSizes = imageSizes;
    this._options = options;
  }

  loadPromospot(downloadToken, domain = null) {
    this._apiManager.getPromospot(downloadToken).then((json) => {
      const kiosquePublications = json.KiosquePublications;
      const publications = [];
      const size = kiosquePublications.length;
      for (let i = 0; i < size; i++) {
        const kiosque = kiosquePublications[i];
        const size1 = kiosque.Publications.length;
        const cpid = kiosque.ContentPackageId;
        const version = kiosque.Version;
        for (let j = 0; j < size1; j++) {
          const pub = kiosque.Publications[j];
          const newPub = this.normalizePubForSwiper(pub, cpid, version, domain);
          if (newPub) {
            publications.push(newPub);
          }
        }
      }
      this.promospotList = publications;
      this.sort();
      this.trigger("promospot:loaded");
    });
  }

  getPromospotList() {
    return this.promospotList;
  }

  sort() {
    this.promospotList.sort((a, b) => {
      return b.Priority - a.Priority;
    });
  }

  normalizePubForSwiper(pub, contentPackageId, version, domain = null) {
    if (
      this._options.onlySupplementsInPromospot &&
      pub.PublicationType.toLowerCase() !== "supplement"
    ) {
      return null;
    }
    const result = pub;
    result.label = pub.PublicationName;
    result.ThumbnailId = pub.ThumbnailPublicationPageId;
    result.imageUrl = generateCoverURL(
      contentPackageId,
      this._imageSizes.S,
      pub.ThumbnailId,
      version,
      domain
    );
    result.ContentPackageId = contentPackageId;
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/common/stores/promospotStore.js